import styled from 'styled-components'

export default styled.ul`
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
`
